export async function initMocks() {
  if (typeof window === 'undefined') {
    const { server } = await import('./server');
    server.listen({
      onUnhandledRequest: 'bypass',
    });
  } else {
    const { worker } = await import('./browser');
    worker.start({
      onUnhandledRequest: 'bypass',
      serviceWorker: {
        /**
         * NOTE : url은 next.config.js에서 설정한 basePath를 기준으로 mockServiceWorker.js의 상대 경로를 설정해야 합니다.
         */
        url: './mockServiceWorker.js',
      },
    });
  }
}
